import { render, staticRenderFns } from "./lojaPerfeitaIndex.vue?vue&type=template&id=0f42fa40&"
import script from "./lojaPerfeitaIndex.vue?vue&type=script&lang=js&"
export * from "./lojaPerfeitaIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports